import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
// import Alert from "react-bootstrap/Alert";
import Modal from "react-modal";
import HelmetWrapper from "../../HelmetWrapper";
import TMEForm from "../../components/Open-pages/trainer-member-engagement/TMEForm";
import WelcomeUser from "../../components/Open-pages/user/WelcomeUser";
// import BackBtn from "../../components/Open-pages/common/BackBtn";
import BackAddBtns from "../../components/Open-pages/target-matrics/common/BackAddBtns";
import TMELogsTable from "../../components/trainer-member-engagement/TMELogsTable";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import Notifications from "../../components/push-notifications/Notifications";

const TrainerMemberEngagement = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // const isNotificationDenied = useSelector(
  //   (state) => state.notification.permission
  // );

  const [pageState, setPageState] = useState(
    JSON.parse(localStorage.getItem("pageState"))
  );
  const { decryptedText: userInfoData, isCustom } = pageState || {};

  const [isModOpen, setIsModOpen] = useState(false);

  const isIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  };

  const handleBack = (e) => {
    e.preventDefault();

    navigate("/open-access/all-pages", {
      state: { userInfo: userInfoData, decryptedText: userInfoData },
    });
  };

  useEffect(() => {
    const savedState = localStorage.getItem("pageState");

    if (savedState) {
      try {
        setPageState(JSON.parse(savedState));
      } catch (error) {
        console.error("Error parsing saved state:", error);
      }
    }
  }, []);

  useEffect(() => {
    if (!pageState) {
      navigate("/open-access", { state: { from: location.pathname } });
    }
  }, [pageState]);

  return (
    <HelmetWrapper title="WTF: Trainer and Member Engagement">
      <Container className="px-50px gobal-container" fluid>
        <Modal
          isOpen={isModOpen}
          onRequestClose={() => setIsModOpen(false)}
          contentLabel="Details Modal"
          ariaHideApp={false}>
          <div className={`createNewCTOModalContainer`}>
            <ModalHeadAndClose
              // title={`All Submitted Details`}
              onClose={() => setIsModOpen(false)}
            />
            <TMELogsTable userInfoData={userInfoData} isCustom={isCustom} />
          </div>
        </Modal>

        {userInfoData && !isIOS() && <Notifications authData={userInfoData} />}

        <Row>
          <Col>
            <WelcomeUser userName={userInfoData?.name} />
            {/* <BackBtn onClickBtn={(e) => handleBack(e)} /> */}

            {/* {isNotificationDenied === "denied" && (
              <Alert variant={"danger"} className="mt30">
                Notification permission is denied. Unable to display desktop
                notifications.
              </Alert>
            )} */}

            <BackAddBtns
              isCustom={isCustom}
              addBtnTxt={"Show Previously Submitted Details"}
              onClickAdd={() => setIsModOpen(true)}
              onClickBack={handleBack}
              isAddBtn={true}
            />
            <TMEForm userInfoData={userInfoData} />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default TrainerMemberEngagement;
